<template>
  <div id="map_container">
  </div>
</template>

<script>
import { mapState } from "vuex";
import mapboxgl from "mapbox-gl/dist/mapbox-gl";

export default {
  name: "map-detail",
  computed: mapState(["record"]),
  data() {
    return {
      map: {},
      geojson_layer: {}
    };
  },
  watch: {
    record: "createMap"
  },
  mounted() {
    this.createMap();
  },
  methods: {
    createMap() {
      mapboxgl.accessToken =
        "pk.eyJ1IjoibWJhcnRvbG9tZSIsImEiOiJjaWVtMThsNmgwMDBtc21rcXM2NDZyZDRyIn0.pjh4R8km1CQLVWRM8Twu_g";

      this.map = new mapboxgl.Map({
        container: "map_container",
        style: "mapbox://styles/mbartolome/cjk8qsnnsdg8f2tr1hobe2tei",
        center: [this.record.x, this.record.y],
        zoom: 8
      });

      if (this.map.getLayer("parcel")) {
        this.map.removeLayer("parcel");
        this.map.removeSource("parcel");
      }
      let self = this;
      if (
        this.map.on("load", function() {
          self.map.addLayer({
            id: "parcel",
            type: "fill",
            source: {
              type: "geojson",
              data: self.record.geo_json
            },
            layout: {},
            paint: {
              "fill-color": "#fff",
              "fill-opacity": 0.3,
              "fill-outline-color": "rgba(255, 0, 0, 1)"
            }
          });
          self.map.flyTo({ center: [self.record.x, self.record.y], zoom: 12 });
        })
      );
    }
  }
};
</script>

<style lang="css">
  @import "~mapbox-gl/dist/mapbox-gl.css";
</style>

<style>
#map_container {
  width: 100%;
  height: 375px;
}
</style>
